import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { SignatureRequest } from 'src/app/models/signature-request.model';
import { ApiService } from 'src/app/services/api.service';
import { SignaturesHeaderService } from 'src/app/services/signatures-header.service';
import { UserService } from 'src/app/services/user.service';
import { AcceptConditionsDialogComponent } from './accept-conditions-dialog/accept-conditions-dialog.component';
import { SignatureRequestService } from 'src/app/services/signature-request.service';
import { TokenService } from 'src/app/services/token.service';
import { PDFDocumentProxy, PDFProgressData, PdfViewerComponent } from 'ng2-pdf-viewer';
import { Document } from 'src/app/models/document.model';

@Component({
  selector: 'app-document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.sass']
})
export class DocumentViewerComponent implements OnInit {

  public MAX_FILE_SIZE_TO_RENDER:number = 5;
  public signature_request:SignatureRequest = null as any;
  documentSource:any = null;
  document:Document = null as any;

  private _page:number = null as any;
  get page():number { return this._page };
  set page(n:number) {
    this._page = n;
    if(this.num_pages!=null && !this.is_document_read && n>=this.num_pages-1) {
      this.is_document_read = true;
    }
  }
  private num_pages:number = null as any;
  public is_document_read:boolean = false;
  public size_too_large:boolean = false;

  constructor(private token:TokenService,
              private api:ApiService,
              private header:SignaturesHeaderService,
              private user:UserService,
              private dialog:MatDialog,
              private signature_request_service:SignatureRequestService) {

  }

  ngOnInit(): void {
    this.header.setAuthStep(2);
    this.fetchSignatureRequest();
  }

  afterLoadComplete(pdf: PDFDocumentProxy) {
    this.num_pages = pdf.numPages
    if(this.num_pages > 10 || this.num_pages <= 2) this.is_document_read = true;
  }

  downloadWithTemporaryUrl() {
    if(this.document.ro_unauthenticated_temporary_download_url!=null) {
      this.downloadFile(this.document.ro_unauthenticated_temporary_download_url);
    }
  }

  private downloadFile(path:string){
    var link=document.createElement('a');
    link.href = path;
    link.download = path.substr(path.lastIndexOf('/') + 1);
    link.target = "_blank";
    link.click();
  }

  private fetchSignatureRequest() {
    this.signature_request_service.signature_request.subscribe(
      data => {
        if(this.signature_request==null && data != null) {
          this.signature_request = data;
          this.checkIfIsAccepted();
          this.processVisibilityOfDocument();
        }
      }
    );
  }

  private checkIfIsAccepted() {
    const me = this.user.getCurrentUser();
    let is_accepted:boolean = false;
    let found:boolean = false;
    let signatory_uuid:string = null as any;

    for(let s of this.signature_request.signatories) {
      if(me.uuid===s.user.uuid) {
        found = true;
        is_accepted = s.accepted;
        signatory_uuid = s.uuid;
        break;
      }
    }

    if(!found) {
      console.error("Signatory not found with my logged in user");
    }
    else if(!is_accepted) {
      this.openAcceptConditionsPopup(signatory_uuid);
    }

  }

  private openAcceptConditionsPopup(signatory_uuid:string) {
    const ref = this.dialog.open(AcceptConditionsDialogComponent, {
      data: { signature_request: this.signature_request, signatory_uuid: signatory_uuid },
      disableClose: true,
      maxWidth: '350px'
    });

    ref.afterClosed().subscribe(
      (data:{success:boolean}) => {
        if(data.success) {

        }
      }
    );
  }

  private viewPdf() {
    this.api.downloadDocument(this.document.uuid).subscribe(
      async data => {
        const buffer = await new Response(data).arrayBuffer();
        const uint = [...new Uint8Array(buffer)];

        this.documentSource = {
          data: uint
        };
      }
    );
  }

  private onPdfSizeTooLarge() {
    this.size_too_large = true;
  }

  private processVisibilityOfDocument() {
    if(this.signature_request.documents.length > 0 ) {
      this.document = this.signature_request.documents[0];
      this.signature_request_service.setDocument(this.document);
      const file_size_in_mb = this.document.ro_file_size / 1000000;
      if(file_size_in_mb < this.MAX_FILE_SIZE_TO_RENDER) {
        this.viewPdf();
      }
      else {
        this.onPdfSizeTooLarge();
      }
    }
  }
}
